import { render, staticRenderFns } from "./NotificacionModals.vue?vue&type=template&id=e6aa43ce"
import script from "./NotificacionModals.vue?vue&type=script&lang=js"
export * from "./NotificacionModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports